import { Stack } from '@mui/material'
import React from 'react'
 
const Progressbar = ({bgcolor,progress,height}) => {
    
    const Parentdiv = {
        height: height,
        width: '100%',
        backgroundColor: '#c3cbdb',
        borderRadius: 40,
        margin: 20
      }
     
      const Childdiv = {
        height: '100%',
        width: `${progress}%`,
        backgroundColor: bgcolor,
       borderRadius:40,
        textAlign: 'right'
      }
     
      const progresstext = {
        paddingTop: 5,
        paddingRight: 10,
        paddingLeft: 15,
        color: '#4a5b82',
        fontWeight: 900
      }
       
    return (
    <div style={Parentdiv}>
      <div style={Childdiv}>
        <Stack>
        <span style={progresstext}>{`${progress}%`}</span>
        </Stack>
      </div>
    </div>
    )
}
 
export default Progressbar;